module.exports = __webpack_public_path__ + "static/index/img/baikal-700.22ed28f5.jpg";